import type { ImageSearchItem } from '../types/imageSearch.types';
import { PexelsInfiniteListView } from './PexelsInfiniteListView';
export const SearchedImagesScreen = ({
  images,
  isLoadingMore,
  hasNextPage,
  onImageSelect,
  onLoadMore
}: {
  images: ImageSearchItem[];
  isLoadingMore: boolean;
  hasNextPage: boolean;
  onImageSelect: (image: ImageSearchItem) => void;
  onLoadMore: () => void;
}) => {
  return <PexelsInfiniteListView images={images} hasNextPage={hasNextPage} onLoadMore={onLoadMore} onImageSelect={onImageSelect} isLoadingMore={isLoadingMore} data-sentry-element="PexelsInfiniteListView" data-sentry-component="SearchedImagesScreen" data-sentry-source-file="SearchedImagesScreen.tsx" />;
};